import { inject, Injectable } from '@angular/core';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { DropdownService } from '@core/services';
import { ApiResponse, Dropdown, DropDownExtension } from '@core/types';
import { QUERY_KEYS } from '@core/constans';
import { environment } from '@environments/environment';
import { lastValueFrom } from 'rxjs';
import { profileStore } from '@core/store';

/**
 * Query service para operaciones de Dropdown
 * Utiliza TanStack Query para caché inteligente y manejo de estados
 */
@Injectable({ providedIn: 'root' })
export class DropdownQuery {
  private dropdownService = inject(DropdownService);
  private profile = inject(profileStore);

  /**
   * Query para obtener los tipos de condominio
   * Cache: 10 minutos (raramente cambian)
   */
  useCondominiumTypes() {
    return injectQuery(() => ({
      queryKey: QUERY_KEYS.dropdowns.condominiumTypes(),
      queryFn: () => lastValueFrom(this.dropdownService.condominiumTypes()),
      select: (data: ApiResponse<DropDownExtension<string, boolean>[]>) => data.data || [],
      staleTime: environment.staleTime,
    }));
  }

  useCommonAreaStatusesDropdown() {
    return injectQuery(() => ({
      queryKey: QUERY_KEYS.dropdowns.commonAreaStatuses(),
      queryFn: () => lastValueFrom(this.dropdownService.commonAreaStatuses()),
      select: (data: ApiResponse<Dropdown<string>[]>) => data.data || [],
      staleTime: environment.staleTime,
    }));
  }

  useReservationStatusesDropdown() {
    return injectQuery(() => ({
      queryKey: QUERY_KEYS.dropdowns.reservationStatuses(),
      queryFn: () => lastValueFrom(this.dropdownService.reservationStatuses()),
      select: (data: ApiResponse<Dropdown<string>[]>) => data.data || [],
      staleTime: environment.staleTime,
    }));
  }

  useDocumentsDropdown() {
    return injectQuery(() => {
      const condominiumId = this.profile.data.activeCondominiumId();
      return {
        queryKey: QUERY_KEYS.dropdowns.documents(condominiumId),
        queryFn: () => lastValueFrom(this.dropdownService.documents()),
        select: (data: ApiResponse<Dropdown<string>[]>) => data.data || [],
        staleTime: environment.staleTime,
        enabled: !!condominiumId,
      };
    });
  }
}

